/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

/**
 * Geolocation utility to handle browser Geolocation API and coordinates
 */

export interface Coordinates {
  latitude: number;
  longitude: number;
}

/**
 * Gets the current position using the browser's Geolocation API
 */
export const getCurrentPosition = (): Promise<Coordinates> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  });
};

/**
 * Simple reverse geocoding using Zippopotam.us or similar free API 
 * for demonstration if needed, or just use lat/lng directly.
 * For now, we'll focus on lat/lng as it's more precise for "near me" searches.
 */
